import React, { useState } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import PageHero from "../components/PageHero";
import { siteMeta, visitDetails, visitFaqs } from "../data/siteContent";

function VisitPage() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    visitors: "",
    message: "",
  });

  const onChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    setFormData({ name: "", contact: "", visitors: "", message: "" });
  };

  return (
    <>
      <PageHero
        eyebrow="Plan Your Visit"
        title="We Would Love to Meet You"
        intro="If you are planning to visit, we hope these details help you come with peace and confidence."
        metaTitle={`Plan Your Visit | ${siteMeta.churchName}`}
      />
      <section className="site-section">
        <Container>
          <Row className="g-5 align-items-start">
            <Col lg={6}>
              <div className="content-panel">
                <h2>Visit Information</h2>
                <div className="visit-summary">
                  {visitDetails.map((item) => (
                    <div key={item.label} className="visit-summary__item">
                      <strong>{item.label}</strong>
                      <span>{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="map-frame">
                <iframe
                  title="Church location map"
                  src={siteMeta.mapEmbed}
                  loading="lazy"
                  allowFullScreen
                ></iframe>
              </div>
            </Col>
            <Col lg={6}>
              <div className="content-panel">
                <h2>Frequently Asked Questions</h2>
                <div className="faq-list">
                  {visitFaqs.map((item) => (
                    <details key={item.question}>
                      <summary>{item.question}</summary>
                      <p>{item.answer}</p>
                    </details>
                  ))}
                </div>
              </div>
              <div className="content-panel">
                <h2>I'm Planning to Visit</h2>
                {submitted ? (
                  <Alert variant="success" onClose={() => setSubmitted(false)} dismissible>
                    Thank you. We look forward to welcoming you.
                  </Alert>
                ) : null}
                <Form onSubmit={onSubmit} className="site-form">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      required
                      name="name"
                      value={formData.name}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Phone or email</Form.Label>
                    <Form.Control
                      required
                      name="contact"
                      value={formData.contact}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Number of visitors</Form.Label>
                    <Form.Control
                      required
                      name="visitors"
                      value={formData.visitors}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="message"
                      value={formData.message}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Button type="submit" className="site-button site-button--primary">
                    I'm Planning to Visit
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default VisitPage;
